import {isIOS, isAndroid} from 'react-device-detect';

const DEFAULT_APP_BUNDLE_ID = 'com.yaknetwork.mobile';

export default function UnilinkContainer(p) {
  const args = p.match.params;
  let targetRoute = `https://${args.org}.yaknetwork.com/app/${args.appId}`;
  if (isIOS) {
    targetRoute = 'https://apps.apple.com/us/app/yak-network/id1528043899';
  }
  if (isAndroid) {
    targetRoute = `https://play.google.com/store/apps/details?id=${DEFAULT_APP_BUNDLE_ID}`;
  }
  if (targetRoute != null) {
    window.location.href = targetRoute;
    return null;
  }
}
